<template>
    <div>
        <b-modal ref="openModal" class="localizationModal" scrollable size="md" title="Ocorrências">

            <h3>#{{ filledValue }}</h3>

            
            <div v-for="occurrence in occurrences" :key="occurrence.id">
                <!-- {{ occurrence }} -->
                <base-row-detail :label="'Data da ocorrência: '" :value="occurrence.createDate"></base-row-detail>
                <b-row class="cargo-data-row">
                    <b-col sm="12" md="5">
                        <label>{{ `ChecklistId: ` }}</label>
                    </b-col>
                    <b-col sm="12" md="6">
                        <a href="#" @click="openChecklistDatails(occurrence.checklistId )" style="color: white">
                            # <u>{{ occurrence.checklistId }}</u>
                        </a>
                    </b-col>
                </b-row>
                <base-row-detail :label="'Descrição: '" :value="occurrence.description"></base-row-detail>
                
                -------------------------------------------------
            </div>
            <pendency-field-details-modal ref="checklistDetails" :id="checklistId" />

            <!-- {{ occurrences }} -->

            <template #modal-footer="{ cancel }">
                <div class="right">
                    <b-button class="ml-2" variant="danger" @click="cancel()">
                        {{ $t("geral.close") }}
                    </b-button>
                </div>
            </template>
        </b-modal>

    </div>
</template>
<script>
export default {
    name: "WorkflowOccurrencesFilledStoryModal",
    components: {
        BaseRowDetail: () => import("@/components_rms/base/BaseRowDetail.vue"),
        "pendency-field-details-modal": () =>
            import("@/pagesRms/checklist/pendency/PedencyFieldDetailsModal.vue"),
    },
    data() {
        return {
            occurrences: {},
            filledValue: "",
            checklistId: ""
        }
    },

    methods: {
        show(integration, value) {
            this.filledValue = value;
            this.getOccurrencesByProcessId(integration);
            this.$refs.openModal.show();
        },
        getOccurrencesByProcessId(integration) {
            this.$apiWorkflow
                .get("/workflowOccurrence/getOccurrencesSystem/" + integration)
                .then((response) => {
                    console.log(response.data);
                    this.occurrences = response.data;
                });
        },
        openChecklistDatails(checklistId) {
            this.checklistId = checklistId.toString();
            this.$refs.checklistDetails.open();
        }
    }
}

</script>

<style scoped>
.right {
    text-align: right;
    width: 100%;
}
</style>
